import { render, staticRenderFns } from "./SpecialPriceNew_Details.vue?vue&type=template&id=17e8d500&"
import script from "./SpecialPriceNew_Details.vue?vue&type=script&lang=js&"
export * from "./SpecialPriceNew_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports